{
  "name": "checkpad-2",
  "version": "0.1.0",
  "private": true,
  "scripts": {
    "serve": "ionic serve",
    "serve-with-config": "ionic serve -c",
    "serve:dev": "npm run serve-with-config -- dev",
    "serve:prod": "npm run serve-with-config -- prod",
    "serve:test": "npm run serve-with-config -- test",
    "serve:dev-org": "npm run serve-with-config -- dev-org",
    "serve:prod-org": "npm run serve-with-config -- prod-org",
    "serve:test-org": "npm run serve-with-config -- test-org",
    "serve:demo-org": "npm run serve-with-config -- demo-org",
    "serve:deeplink": "npm run serve-with-config -- app-deeplink",
    "serve:vivantes": "npm run serve-with-config -- vivantes",
    "generate-build-info": "node scripts/generate-build-info.js",
    "build": "npm run generate-build-info && ionic build -c",
    "build:dev": "npm run build -- development",
    "build:prod": "npm run build -- prod",
    "build:test": "npm run build -- test",
    "build:dev-org": "npm run build -- development-org",
    "build:prod-org": "npm run build -- prod-org",
    "build:test-org": "npm run build -- test-org",
    "build:demo-org": "npm run build -- demo-org",
    "build:deeplink": "npm run build -- app-deeplink",
    "build:vivantes": "npm run build -- vivantes",
    "sync": "npx cap sync",
    "prebuild": "npm run generate-build-info && npm run sql-wasm:remove",
    "build:android": "npm run prebuild && ionic capacitor build android --configuration=app-deeplink",
    "build:ios": "npm run prebuild && ionic capacitor build ios",
    "open:ios": "npm run sync && ionic capacitor open ios",
    "open:android": "npm run sync && npx cap open android",
    "serve:android": "npm run prebuild && ionic cap run android -l --external --open",
    "serve:ios": "npm run prebuild && ionic cap run ios -l --external --open",
    "sql-wasm:copy": "copyfiles -u 3 node_modules/sql.js/dist/sql-wasm.wasm src/assets",
    "sql-wasm:remove": "rimraf src/assets/sql-wasm.wasm",
    "electron:install": "cd electron && npm install && cd ..",
    "electron:prepare": "npm run build:dev && npx cap sync @capacitor-community/electron && npx cap copy @capacitor-community/electron && cd electron",
    "electron-build:app": "electron:install && electron:prepare && npm run electron-build",
    "electron-build:dist": "electron:install && electron:prepare  && npm run electron-dist",
    "lint": "ng lint --silent",
    "lint:fix": "ng lint --fix --silent",
    "format": "prettier --check .",
    "format:fix": "prettier --write ."
  },
  "dependencies": {
    "@angular/animations": "17.2.1",
    "@angular/cdk": "17.2.1",
    "@angular/common": "17.2.1",
    "@angular/compiler": "17.2.1",
    "@angular/core": "17.2.1",
    "@angular/elements": "17.2.1",
    "@angular/forms": "17.2.1",
    "@angular/material": "17.2.1",
    "@angular/material-experimental": "17.2.1",
    "@angular/platform-browser": "17.2.1",
    "@angular/platform-browser-dynamic": "17.2.1",
    "@angular/router": "17.2.1",
    "@angular/service-worker": "17.2.1",
    "@babybeet/angular-tooltip": "1.1.1",
    "@capacitor-community/electron": "^5.0.1",
    "@capacitor-community/sqlite": "5.6.3",
    "@capacitor-mlkit/barcode-scanning": "^5.3.0",
    "@capacitor/android": "5.7.0",
    "@capacitor/app": "5.0.7",
    "@capacitor/browser": "^5.2.0",
    "@capacitor/core": "5.7.4",
    "@capacitor/device": "5.0.7",
    "@capacitor/haptics": "5.0.7",
    "@capacitor/ios": "5.7.0",
    "@capacitor/keyboard": "5.0.8",
    "@capacitor/network": "^5.0.8",
    "@capacitor/preferences": "5.0.7",
    "@capacitor/status-bar": "5.0.7",
    "@capacitor/toast": "^5.0.7",
    "@cornerstonejs/calculate-suv": "^1.1.0",
    "@cornerstonejs/core": "^1.86.0",
    "@cornerstonejs/dicom-image-loader": "^1.86.0",
    "@cornerstonejs/streaming-image-volume-loader": "^1.86.0",
    "@cornerstonejs/tools": "^1.86.0",
    "@formio/angular": "7.0.0",
    "@ionic/angular": "7.8.1",
    "@ionic/pwa-elements": "^3.2.2",
    "@lohmann-birkner/luic": "^0.9.8",
    "@material-design-icons/font": "^0.14.13",
    "@ngrx/effects": "^17.0.1",
    "@ngrx/schematics": "^17.1.0",
    "@ngrx/store": "^17.0.1",
    "@ngrx/store-devtools": "^17.0.1",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^8.0.0",
    "@rxfx/bus": "^1.1.0",
    "@schematics/angular": "^17.0.10",
    "@tailwindcss/typography": "^0.5.15",
    "@tiptap/core": "^2.5.9",
    "@tiptap/extension-color": "^2.5.9",
    "@tiptap/extension-font-family": "^2.8.0",
    "@tiptap/extension-text-align": "^2.5.9",
    "@tiptap/extension-text-style": "^2.5.9",
    "@tiptap/extension-underline": "^2.5.9",
    "@tiptap/starter-kit": "^2.5.9",
    "angular-oauth2-oidc": "^17.0.2",
    "angular-oauth2-oidc-jwks": "^17.0.2",
    "angularx-qrcode": "^17.0.0",
    "async-mutex": "^0.5.0",
    "chart.js": "^4.3.0",
    "chartjs-adapter-dayjs-4": "^1.0.4",
    "chartjs-plugin-annotation": "^3.0.1",
    "crypto-js": "^4.2.0",
    "dayjs": "^1.11.10",
    "dicom-parser": "^1.8.21",
    "diff-match-patch": "^1.0.5",
    "event-source-polyfill": "^1.0.31",
    "fabric": "6.5.4",
    "gridstack": "^10.3.1",
    "html-to-pdfmake": "2.5.13",
    "html2canvas": "^1.4.1",
    "jeep-sqlite": "2.6.2",
    "jose": "^5.2.1",
    "ng-event-bus": "^6.0.0",
    "ng2-charts": "^6.0.1",
    "ngx-ellipsis": "^5.0.1",
    "ngx-tiptap": "^10.1.0",
    "pdfjs-dist": "^4.5.136",
    "pdfmake": "0.2.14",
    "rxjs": "~7.8.0",
    "sql.js": "1.10.2",
    "tslib": "^2.3.0",
    "uuid": "^9.0.1",
    "zod": "^3.24.1",
    "zone.js": "~0.14.2"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "17.2.1",
    "@angular-devkit/schematics": "17.2.1",
    "@angular-eslint/builder": "17.2.1",
    "@angular-eslint/eslint-plugin": "17.2.1",
    "@angular-eslint/eslint-plugin-template": "17.2.1",
    "@angular-eslint/schematics": "17.2.1",
    "@angular-eslint/template-parser": "17.2.1",
    "@angular/cli": "17.2.1",
    "@angular/compiler-cli": "17.2.1",
    "@angular/language-service": "17.2.1",
    "@capacitor/cli": "5.7.0",
    "@ionic/angular-toolkit": "11.0.1",
    "@ionic/cli": "^7.2.0",
    "@ngrx/store-devtools": "^17.0.1",
    "@types/crypto-js": "^4.2.2",
    "@types/diff-match-patch": "^1.0.36",
    "@types/event-source-polyfill": "^1.0.5",
    "@types/html-to-pdfmake": "^2.4.4",
    "@types/node": "20.11.24",
    "@types/pdfmake": "^0.2.9",
    "@types/qrcode": "^1.5.5",
    "@types/uuid": "^9.0.8",
    "@typescript-eslint/eslint-plugin": "6.19.0",
    "@typescript-eslint/parser": "6.19.0",
    "copyfiles": "^2.4.1",
    "eslint": "^8.56.0",
    "eslint-config-prettier": "^10.0.1",
    "eslint-plugin-import": "^2.31.0",
    "eslint-plugin-prettier": "^5.2.3",
    "eslint-plugin-simple-import-sort": "^12.1.1",
    "eslint-plugin-unused-imports": "^4.1.4",
    "prettier": "^3.5.0",
    "prettier-eslint": "^16.3.0",
    "rimraf": "^5.0.5",
    "tailwindcss": "^3.4.3",
    "ts-node": "^8.3.0",
    "typescript": "~5.2.2"
  }
}
